let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fjvDn")).then(() => parcelRequire('4Kji8'));